import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Platform } from './pages/Platform';
import { BAS } from './pages/BAS';
import { ExposureValidation, AutomatedPenTesting, PicusSwarm, Integrations } from './pages/CustomPages';
import { GenericPage } from './pages/GenericPage';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/platform" element={<Platform data-id="element-6" />} data-id="element-5" />
          <Route path="/breach-and-attack-simulation" element={<BAS data-id="element-8" />} data-id="element-7" />
          <Route path="/platform/exposure-validation" element={<ExposureValidation data-id="element-10" />} data-id="element-9" />
          <Route path="/platform/automated-penetration-testing" element={<AutomatedPenTesting data-id="element-12" />} data-id="element-11" />
          <Route path="/platform/picus-swarm" element={<PicusSwarm data-id="element-14" />} data-id="element-13" />
          <Route path="/integrations" element={<Integrations data-id="element-16" />} data-id="element-15" />

          {/* Research Pages */}
          <Route path="/research" element={<GenericPage hero={{
          eyebrow: 'Picus Research',
          headline: 'Research that turns market signals into operational insight',
          subhead: 'Picus Research turns validation data and threat intelligence into practical insight teams can actually use. This is where we publish the data, benchmarks, and analysis that help buyers and operators understand what matters.',
          primaryCta: {
            label: 'Explore Threat Response Index',
            to: '/research/threat-response-index'
          },
          secondaryCta: {
            label: 'See Picus Labs',
            to: '/research/picus-labs'
          }
        }} modules={[{
          title: 'See how the market responds',
          subtitle: 'Picus Research is built around one idea: published response is not the same as validated protection. The best research closes that gap.',
          type: 'text',
          graphic: 'Disclosure → response → validated protection timeline.'
        }, {
          title: 'Flagship research built for practitioners',
          subtitle: 'From the Threat Response Index to Red Report and Blue Report, Picus publishes content that helps teams understand threat response, validation, and readiness.',
          type: 'cards',
          cards: [{
            title: 'Threat Response Index',
            to: '/research/threat-response-index'
          }, {
            title: 'Red Report',
            to: '/research/red-report'
          }, {
            title: 'Blue Report',
            to: '/research/blue-report'
          }, {
            title: 'Picus Labs',
            to: '/research/picus-labs'
          }],
          graphic: 'Three flagship content cards with one live-style index card pinned first.'
        }, {
          title: 'Market authority backed by platform visibility',
          subtitle: 'Picus sees validation data, security context, and response patterns across the stack. Research is where that visibility becomes useful insight.',
          type: 'text',
          graphic: 'Platform-to-research pipeline visual.'
        }, {
          title: 'Future posture, grounded in real operations',
          subtitle: 'Research is where Picus can look most forward without becoming abstract. The point is still the same: prove what works, know what matters, and make better decisions faster.',
          type: 'text',
          graphic: 'Research outputs feeding practical operator use cases.'
        }]} data-id="element-18" />} data-id="element-17" />

          <Route path="/research/threat-response-index" element={<GenericPage hero={{
          eyebrow: 'Picus Research',
          headline: 'From disclosure to validated protection',
          subhead: 'The Picus Threat Response Index tracks how quickly and how effectively security vendors and organizations respond to major emerging threats. It turns fragmented market signals into a clear view of readiness and lag.',
          primaryCta: {
            label: 'Explore Latest Threats',
            to: '/research/threat-response-index'
          },
          secondaryCta: {
            label: 'See Methodology',
            to: '/research'
          }
        }} modules={[{
          title: 'Published response is not the same as validated protection',
          type: 'text',
          graphic: 'Disclosure → vendor response → validated protection timeline.'
        }, {
          title: 'Track the threats that matter now',
          type: 'text',
          graphic: 'Live threat tracker with severity and response status.'
        }, {
          title: 'Benchmark vendors, industries, and regions',
          type: 'text',
          graphic: 'Benchmark comparison across vendors, industries, and regions.'
        }]} data-id="element-20" />} data-id="element-19" />

          <Route path="/research/picus-labs" element={<GenericPage hero={{
          eyebrow: 'Picus Research',
          headline: 'Validation research built for the real world',
          subhead: 'Picus Labs turns frontline threat analysis and validation expertise into practical research. From emerging threat scenarios to response intelligence, Labs is where platform knowledge becomes market authority.',
          primaryCta: {
            label: 'Explore Labs',
            to: '/research/picus-labs'
          },
          secondaryCta: {
            label: 'See Emerging Threats',
            to: '/research'
          }
        }} modules={[{
          title: 'Research that starts with what teams actually face',
          type: 'text',
          graphic: 'Threat signal entering a research pipeline.'
        }, {
          title: 'From threat signal to validation content',
          type: 'text',
          graphic: 'Threat signal → validation content → platform update flow.'
        }, {
          title: 'Built to support operators, not just readers',
          type: 'text',
          graphic: 'Operator workflow with research inputs.'
        }]} data-id="element-22" />} data-id="element-21" />

          <Route path="/research/red-report" element={<GenericPage hero={{
          eyebrow: 'Picus Research',
          headline: 'What the offense side shows',
          subhead: 'The Red Report captures offensive patterns, risks, and practical lessons teams need to understand how exposure evolves. It is built to help teams move from theory to evidence.',
          primaryCta: {
            label: 'Download the Red Report',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Research',
            to: '/research'
          }
        }} modules={[{
          title: 'Offense changes faster than old reporting cycles',
          type: 'text',
          graphic: 'Fast-moving offense timeline versus slow reporting cycle.'
        }, {
          title: 'Built for teams that want signal, not noise',
          type: 'text',
          graphic: 'Signal-rich report panel versus noise-heavy feed.'
        }]} data-id="element-24" />} data-id="element-23" />

          <Route path="/research/blue-report" element={<GenericPage hero={{
          eyebrow: 'Picus Research',
          headline: 'What the defense side proves',
          subhead: 'The Blue Report focuses on how defensive posture performs in practice. It helps teams understand where controls hold, where they fail, and what to improve next.',
          primaryCta: {
            label: 'Download the Blue Report',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Research',
            to: '/research'
          }
        }} modules={[{
          title: 'Readiness needs evidence',
          type: 'text',
          graphic: 'Evidence-backed readiness dashboard.'
        }, {
          title: 'Defensive optimization starts with proof',
          type: 'text',
          graphic: 'Defensive optimization loop with proof checkpoints.'
        }]} data-id="element-26" />} data-id="element-25" />

          {/* Company Pages */}
          <Route path="/company/about" element={<GenericPage hero={{
          eyebrow: 'Company',
          headline: 'Built by validation pioneers',
          subhead: 'Picus has been helping security teams validate what works for more than a decade. Today, Picus Platform extends that heritage into a broader model for proving what matters and reducing the gap between finding and action.',
          primaryCta: {
            label: 'Talk to Picus',
            to: '/contact'
          },
          secondaryCta: {
            label: 'Meet Leadership',
            to: '/company/about'
          }
        }} modules={[{
          title: 'Built around evidence',
          subtitle: 'Picus exists to help security teams replace assumptions with validated evidence. That has been true since the beginning.',
          type: 'text',
          graphic: 'Assumption → evidence line.'
        }, {
          title: 'A broader platform, grounded in the same discipline',
          subtitle: 'What started as category leadership in Breach and Attack Simulation now extends into Exposure Validation, Automated Penetration Testing, and Swarm.',
          type: 'text',
          graphic: 'Evolution strip from BAS to full platform.'
        }, {
          title: 'Made for the teams doing the work',
          subtitle: 'Picus is built for security teams that need practical answers, not category theater.',
          type: 'text',
          graphic: 'Operator / platform / outcome triangle.'
        }]} data-id="element-28" />} data-id="element-27" />

          <Route path="/company/customers" element={<GenericPage hero={{
          eyebrow: 'Company',
          headline: 'Trusted by teams that need evidence, not guesses',
          subhead: 'Customers use Picus to prove controls work, validate what matters, and reduce wasted effort. The goal is not more noise. It is more confidence.',
          primaryCta: {
            label: 'Read Customer Stories',
            to: '/company/customers'
          },
          secondaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          }
        }} modules={[{
          title: 'Built for real environments',
          subtitle: 'Picus supports teams across financial services, healthcare, energy, telecom, and other high-stakes environments.',
          type: 'logos',
          graphic: 'Industry logo grid.'
        }, {
          title: 'Used to improve decisions, not just reporting',
          subtitle: 'Customers use Picus to validate controls, prioritize remediation, measure readiness, and justify investments.',
          type: 'cards',
          cards: [{
            title: 'Validate Controls',
            description: 'Prove the stack works.'
          }, {
            title: 'Prioritize Remediation',
            description: 'Fix what matters.'
          }, {
            title: 'Measure Readiness',
            description: 'Know where you stand.'
          }, {
            title: 'Justify Investments',
            description: 'Show ROI with evidence.'
          }],
          graphic: 'Four outcome cards.'
        }, {
          title: 'Proof from the field',
          subtitle: 'Use customer quotes and proof points that emphasize confidence, readiness, and reduced wasted effort.',
          type: 'text',
          proof_chips: ['4.9 on G2', '4.8 on Gartner Peer Insights', '2x more attacks prevented within 3 months', 'Sutter Health cut attack simulation time from weeks to under an hour'],
          graphic: 'Rotating quote card with role and industry.'
        }]} data-id="element-30" />} data-id="element-29" />

          <Route path="/company/partners" element={<GenericPage hero={{
          eyebrow: 'Company',
          headline: 'Better with the ecosystem around it',
          subhead: 'Picus works with technology and channel partners to extend validation across real customer environments.',
          primaryCta: {
            label: 'See Technology Alliances',
            to: '/company/partners'
          },
          secondaryCta: {
            label: 'Join the Partner Program',
            to: '/contact'
          }
        }} modules={[{
          title: 'Technology alliances create context',
          type: 'text',
          graphic: 'Technology partner logos in an orbit.'
        }, {
          title: 'Channel partnerships expand reach',
          type: 'text',
          graphic: 'Channel partner network map.'
        }, {
          title: 'Built to fit into existing motions',
          type: 'text',
          graphic: 'Partner integration workflow.'
        }]} data-id="element-32" />} data-id="element-31" />

          <Route path="/company/careers" element={<GenericPage hero={{
          eyebrow: 'Company',
          headline: 'Build the future of security validation',
          subhead: 'Picus is building a more useful operating model for security teams. That requires people who care about evidence, scale, and product truth more than buzzwords.',
          primaryCta: {
            label: 'See Open Roles',
            to: '/company/careers'
          },
          secondaryCta: {
            label: 'Learn About Picus',
            to: '/company/about'
          }
        }} modules={[{
          title: 'Work on real problems',
          type: 'text',
          graphic: 'Real-world security challenge cards.'
        }, {
          title: 'Build things buyers can feel',
          type: 'text',
          graphic: 'Product impact showcase.'
        }, {
          title: 'Join a team that values substance',
          type: 'text',
          graphic: 'Team culture and values strip.'
        }]} data-id="element-34" />} data-id="element-33" />

          {/* Secondary Templates */}
          <Route path="/security-control-validation" element={<GenericPage hero={{
          eyebrow: 'Picus Platform',
          headline: 'Validate the controls you already paid for',
          subhead: 'Security Control Validation helps teams prove whether prevention and detection controls are working as expected. It turns assumptions about the stack into evidence about the stack.'
        }} modules={[]} data-id="element-36" />} data-id="element-35" />

          <Route path="/attack-surface-validation" element={<GenericPage hero={{
          eyebrow: 'Picus Platform',
          headline: 'Validate what is exposed and why it matters',
          subhead: 'Attack Surface Validation helps teams move beyond inventory and discovery by validating which exposed assets and weaknesses actually create meaningful risk.'
        }} modules={[]} data-id="element-38" />} data-id="element-37" />

          <Route path="/cloud-security-validation" element={<GenericPage hero={{
          eyebrow: 'Picus Platform',
          headline: 'Validate cloud changes before they become cloud risk',
          subhead: 'Cloud Security Validation helps teams test how cloud posture, controls, and attack paths hold up as environments change.'
        }} modules={[]} data-id="element-40" />} data-id="element-39" />

          <Route path="/attack-path-validation" element={<GenericPage hero={{
          eyebrow: 'Picus Platform',
          headline: 'See the paths that matter most',
          subhead: 'Attack Path Validation helps teams understand how weaknesses connect into meaningful routes to impact. It turns isolated findings into exploitability stories.'
        }} modules={[]} data-id="element-42" />} data-id="element-41" />

          <Route path="/detection-rule-validation" element={<GenericPage hero={{
          eyebrow: 'Picus Platform',
          headline: 'Validate the rules your SOC relies on',
          subhead: 'Detection Rule Validation helps teams prove whether rules actually fire when they should and whether detections are tuned to real attack behavior.'
        }} modules={[]} data-id="element-44" />} data-id="element-43" />

          {/* Hubs */}
          <Route path="/use-cases" element={<GenericPage hero={{
          headline: 'Start with the problem you need to solve',
          subhead: 'Some teams come to Picus because they need BAS. Others need to know what to fix or whether an attacker can really exploit a path. Use cases give buyers a faster way to map platform value to immediate pain.',
          primaryCta: {
            label: 'See the Platform',
            to: '/platform'
          },
          secondaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          }
        }} modules={[{
          title: 'Buyers do not start with taxonomy',
          subtitle: 'They start with a practical question: do our controls work, what should we fix, or how could an attacker actually get through? Picus Platform supports all three motions.',
          type: 'cards',
          cards: [{
            title: 'Emerging Threat Response',
            to: '/use-cases/emerging-threat-response'
          }, {
            title: 'Validate Security Controls',
            to: '/use-cases/validate-security-controls'
          }, {
            title: 'Validate Detection Rules',
            to: '/use-cases/validate-detection-rules'
          }, {
            title: 'Prioritize Real Exposure',
            to: '/use-cases/prioritize-real-exposure'
          }, {
            title: 'Reduce Manual Triage',
            to: '/use-cases/reduce-manual-triage'
          }, {
            title: 'Accelerate Remediation',
            to: '/use-cases/accelerate-remediation'
          }, {
            title: 'AI Security Validation',
            to: '/use-cases/ai-security-validation'
          }, {
            title: 'Prove Readiness',
            to: '/use-cases/prove-readiness'
          }],
          graphic: 'Three buyer questions in a row, each mapping to BAS, Exposure Validation, or Automated Penetration Testing.'
        }, {
          title: 'Use cases make the platform easier to navigate',
          subtitle: 'Use cases are the shortest path from pain to value. They help teams start with what hurts now, then grow into the broader platform over time.',
          type: 'text',
          graphic: 'Pain → use case → platform motion → action.'
        }]} data-id="element-46" />} data-id="element-45" />

          <Route path="/industries" element={<GenericPage hero={{
          headline: "Validation for environments that can't afford to guess",
          subhead: 'Different industries face different control stacks, regulations, and attack realities. Picus helps teams validate what matters in the context of their environment — not a generic model.',
          primaryCta: {
            label: 'Explore Industries',
            to: '/industries'
          },
          secondaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          }
        }} modules={[{
          title: 'Different environments. One validation platform.',
          subtitle: 'Buyers want proof that Picus understands the world they operate in. Industry pages help make that pattern match immediate.',
          type: 'cards',
          cards: [{
            title: 'Financial Services',
            to: '/industries/financial-services'
          }, {
            title: 'Healthcare',
            to: '/industries/healthcare'
          }, {
            title: 'IT / OT',
            to: '/industries/it-ot'
          }, {
            title: 'Critical Infrastructure',
            to: '/industries/critical-infrastructure'
          }, {
            title: 'Manufacturing',
            to: '/industries/manufacturing'
          }, {
            title: 'Retail / eCommerce',
            to: '/industries/retail-ecommerce'
          }, {
            title: 'Public Sector',
            to: '/industries/public-sector'
          }, {
            title: 'Technology / SaaS',
            to: '/industries/technology-saas'
          }],
          graphic: 'Cards for Financial Services, Healthcare, IT / OT, Critical Infrastructure, Manufacturing, Retail, Public Sector, Technology / SaaS.'
        }, {
          title: 'Context changes by industry.',
          subtitle: 'The tools, control layers, business priorities, and regulatory pressures are different across every sector. Validation needs to reflect that reality.',
          type: 'text',
          graphic: 'One platform with different environment overlays.'
        }, {
          title: 'Start with the environment that looks most like yours.',
          subtitle: 'Use the industry pages to see the problems, use cases, and validation motions most relevant to your team.',
          type: 'text',
          graphic: 'Industry selector strip.'
        }]} data-id="element-48" />} data-id="element-47" />

          <Route path="/frameworks-and-compliance" element={<GenericPage hero={{
          headline: 'Move from checkbox confidence to validated readiness',
          subhead: 'Frameworks and compliance obligations create requirements. Validation helps teams prove whether controls, detections, and remediation actually hold up in practice.',
          primaryCta: {
            label: 'Explore Frameworks',
            to: '/frameworks-and-compliance'
          },
          secondaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          }
        }} modules={[{
          title: 'Requirements are easier to satisfy when controls are proven',
          subtitle: 'Frameworks create obligations. Validation turns them into evidence.',
          type: 'cards',
          cards: [{
            title: 'CTEM',
            to: '/frameworks-and-compliance/ctem'
          }, {
            title: 'MITRE ATT&CK',
            to: '/frameworks-and-compliance/mitre-attack'
          }, {
            title: 'DORA',
            to: '/frameworks-and-compliance/dora'
          }, {
            title: 'HIPAA',
            to: '/frameworks-and-compliance/hipaa'
          }, {
            title: 'NIST CSF',
            to: '/frameworks-and-compliance/nist-csf'
          }, {
            title: 'PCI DSS',
            to: '/frameworks-and-compliance/pci-dss'
          }, {
            title: 'NIS2',
            to: '/frameworks-and-compliance/nis2'
          }],
          graphic: 'Requirement → validation → evidence path.'
        }, {
          title: 'The gap is usually not policy',
          subtitle: 'The gap is proving that the controls, detections, and workflows behind policy actually work.',
          type: 'text',
          graphic: 'Policy doc on left, validated system evidence on right.'
        }, {
          title: 'Start with the framework your team already talks about',
          subtitle: 'Use framework pages to connect Picus Platform to the control and evidence conversations you already have.',
          type: 'text',
          graphic: 'Framework selector strip.'
        }]} data-id="element-50" />} data-id="element-49" />

          {/* Use Case Sub-pages */}
          <Route path="/use-cases/emerging-threat-response" element={<GenericPage hero={{
          headline: 'Validate readiness against what changed last night',
          subhead: 'When a new threat, campaign, or technique appears, teams need to know whether it matters in their environment and what to do next. Picus helps reduce the time between emerging threat and validated response.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Research',
            to: '/research'
          }
        }} modules={[{
          title: 'New threat. Immediate question.',
          subtitle: 'The question is not whether the threat exists. The question is whether it matters here, now, in this environment.',
          type: 'text',
          graphic: 'Threat bulletin card on left, environment-specific decision card on right.'
        }, {
          title: 'Faster than manual coordination.',
          subtitle: 'Manual handoffs are too slow for emerging threat response. Picus helps teams trigger validation, identify gaps, and route action faster than a ticket-and-email model.',
          type: 'text',
          graphic: 'Manual path versus Picus path.'
        }, {
          title: 'Built for signal-driven validation.',
          subtitle: 'Threat response works best when signals trigger validation automatically. That is how teams close the gap between disclosure and action.',
          type: 'text',
          graphic: 'Threat signal → validate controls → validate exposure → action.'
        }]} data-id="element-52" />} data-id="element-51" />

          <Route path="/use-cases/validate-security-controls" element={<GenericPage hero={{
          headline: 'Validate the controls that protect the business',
          subhead: 'Picus helps teams continuously prove whether prevention and detection controls are working as expected. That turns control spend into evidence, not assumptions.',
          primaryCta: {
            label: 'See BAS',
            to: '/breach-and-attack-simulation'
          },
          secondaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          }
        }} modules={[{
          title: 'Trust is not enough.',
          subtitle: 'Control confidence should come from measured performance, not architecture diagrams. Picus helps teams prove whether controls are actually doing their job.',
          type: 'text',
          graphic: 'Assumed state versus validated state.'
        }, {
          title: 'Tune the stack with evidence.',
          subtitle: 'Picus helps teams see where controls hold, where they fail, and what to tune next. That reduces wasted effort and increases confidence in the stack.',
          type: 'text',
          graphic: 'Control scorecards with recommended actions.'
        }, {
          title: 'A strong place to start.',
          subtitle: 'For many buyers, this is the first pain they need to solve. Picus uses BAS to answer it quickly, then expands into broader platform value over time.',
          type: 'text',
          graphic: 'BAS tile growing into platform map.'
        }]} data-id="element-54" />} data-id="element-53" />

          <Route path="/use-cases/validate-detection-rules" element={<GenericPage hero={{
          headline: 'Validate the rules your SOC depends on',
          subhead: 'Detection rules are only useful if they fire when they should. Picus helps teams test rule performance against real attack behavior and identify where tuning is needed.',
          primaryCta: {
            label: 'See Detection Rule Validation',
            to: '/platform/detection-rule-validation'
          },
          secondaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          }
        }} modules={[{
          title: 'Rule volume is not rule quality.',
          subtitle: 'A large rule set is not the same as strong coverage. Picus helps teams validate whether the rules that matter are actually working.',
          type: 'text',
          graphic: 'Many rules versus validated rules.'
        }, {
          title: 'Test detections against real behavior.',
          subtitle: 'Teams need evidence that detections fire when they should, not just confidence that the rule exists in the system.',
          type: 'text',
          graphic: 'Live attack behavior hitting a detection engine.'
        }, {
          title: 'Reduce wasted SOC effort.',
          subtitle: 'Better rule validation means fewer blind spots, less false confidence, and faster tuning for the detections that matter most.',
          type: 'text',
          graphic: 'Blind spot / tuned / validated progression.'
        }]} data-id="element-56" />} data-id="element-55" />

          <Route path="/use-cases/prioritize-real-exposure" element={<GenericPage hero={{
          headline: 'Stop treating scanner output like a remediation plan',
          subhead: 'Picus helps teams distinguish between weaknesses that exist and weaknesses that actually matter. That is how you reduce noise and focus on the right work first.',
          primaryCta: {
            label: 'See Exposure Validation',
            to: '/platform/exposure-validation'
          },
          secondaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          }
        }} modules={[{
          title: 'Volume is not priority.',
          subtitle: 'The existence of a finding is not the same as proof of risk. Picus helps turn broad discovery into evidence-backed priority.',
          type: 'text',
          graphic: 'Raw findings cloud narrowing into a validated queue.'
        }, {
          title: 'Theoretical is not the same as actionable.',
          subtitle: 'Picus uses environment context, control performance, and path relevance to help teams separate noise from real operational risk.',
          type: 'text',
          graphic: 'Theoretical vs validated vs prioritized.'
        }, {
          title: 'Less debate. Better decisions.',
          subtitle: 'When teams share the same evidence-backed list, they spend less time arguing and more time fixing the right things.',
          type: 'text',
          graphic: 'Three team dashboards becoming one common queue.'
        }]} data-id="element-58" />} data-id="element-57" />

          <Route path="/use-cases/reduce-manual-triage" element={<GenericPage hero={{
          headline: 'Spend less time sorting. More time acting.',
          subhead: 'Picus helps teams reduce the manual drag between signal, finding, priority, and action. That matters even more as environments and threats change faster.',
          primaryCta: {
            label: 'See Picus Swarm',
            to: '/platform/picus-swarm'
          },
          secondaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          }
        }} modules={[{
          title: 'Manual sorting does not scale.',
          subtitle: 'As teams collect more signals and more findings, the human effort required to sort and route them grows faster than the team does.',
          type: 'text',
          graphic: 'Escalating queue sizes versus flat headcount.'
        }, {
          title: 'Picus cuts the coordination drag.',
          subtitle: 'Picus helps teams validate what changed, connect the right context, and reduce unnecessary handoffs between teams.',
          type: 'text',
          graphic: 'Signal → validated action workflow.'
        }, {
          title: 'Less administrative burden. Better use of talent.',
          subtitle: 'The goal is not to replace operators. It is to free them from repetitive coordination work so they can focus on higher-value decisions.',
          type: 'text',
          graphic: 'Admin-heavy work shrinking while strategic work expands.'
        }]} data-id="element-60" />} data-id="element-59" />

          <Route path="/use-cases/accelerate-remediation" element={<GenericPage hero={{
          headline: 'Get from finding to fix faster',
          subhead: 'Picus helps teams focus on what matters, route the right context, and revalidate after change. The result is less wasted effort and faster closure.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See the Platform',
            to: '/platform'
          }
        }} modules={[{
          title: 'The point is not to find more.',
          subtitle: 'The point is to close the right gaps faster. Picus helps teams shrink the distance between validated problem and validated fix.',
          type: 'text',
          graphic: 'Open finding → validated fix state transition.'
        }, {
          title: 'Context improves remediation speed.',
          subtitle: 'Vendor-specific guidance, environment context, and evidence-backed priority all help teams reduce wasted work and move faster.',
          type: 'text',
          graphic: 'Priority card plus guidance plus owner assignment.'
        }, {
          title: 'Revalidation closes the loop.',
          subtitle: 'A fix is not complete until the gap is actually closed. Picus helps teams validate the outcome, not just the work ticket.',
          type: 'text',
          graphic: 'Ticket closed versus gap closed comparison.'
        }]} data-id="element-62" />} data-id="element-61" />

          <Route path="/use-cases/ai-security-validation" element={<GenericPage hero={{
          headline: 'Validate AI controls before AI becomes your blind spot',
          subhead: 'As teams adopt more AI, they need to validate whether controls, policies, and safeguards actually hold up. Picus helps bring validation discipline to AI-native risk.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Picus Swarm',
            to: '/platform/picus-swarm'
          }
        }} modules={[{
          title: 'Every vendor has AI now.',
          subtitle: 'The harder question is whether that AI understands your environment well enough to operate usefully inside it.',
          type: 'text',
          graphic: 'Generic AI output versus context-rich platform AI.'
        }, {
          title: 'AI-native systems still need validation.',
          subtitle: 'Policy, access, controls, prompts, and workflows can all drift. Picus helps teams validate whether safeguards are working, not just whether they exist.',
          type: 'text',
          graphic: 'Guardrail check panel.'
        }, {
          title: 'The future still needs proof.',
          subtitle: 'Even AI-native security operations need evidence. Picus helps teams keep that evidence grounded in real context and real control performance.',
          type: 'text',
          graphic: 'Evidence chain over AI workflow.'
        }]} data-id="element-64" />} data-id="element-63" />

          <Route path="/use-cases/prove-readiness" element={<GenericPage hero={{
          headline: 'Give leadership evidence, not reassurance',
          subhead: 'Security leaders need more than dashboards and claims. Picus helps teams generate validated evidence of readiness they can take to leadership with confidence.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Research',
            to: '/research'
          }
        }} modules={[{
          title: 'Confidence is hard to defend without evidence.',
          subtitle: 'Leaders are expected to justify spend, explain readiness, and defend posture. Picus helps replace assumption-based reporting with validated evidence.',
          type: 'text',
          graphic: 'Assumed readiness vs evidence-backed readiness.'
        }, {
          title: 'Readiness is not a static state.',
          subtitle: 'Threats, controls, and environments change constantly. Picus helps teams prove what is true now, not what was true last quarter.',
          type: 'text',
          graphic: 'Readiness trend line over time.'
        }, {
          title: 'Built for decisions, not theater.',
          subtitle: 'The value is not just better dashboards. The value is giving leaders evidence they can actually use to make better choices.',
          type: 'text',
          graphic: 'Board / CISO / operator alignment panel.'
        }]} data-id="element-66" />} data-id="element-65" />

          {/* Industry Sub-pages */}
          <Route path="/industries/financial-services" element={<GenericPage hero={{
          headline: 'Validate what matters in high-pressure financial environments',
          subhead: 'Financial institutions face high-value targets, strict oversight, and constant pressure to prove controls work. Picus helps teams validate defenses, prioritize exposures, and act faster with evidence.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Frameworks',
            to: '/frameworks-and-compliance'
          }
        }} modules={[{
          title: 'Pressure comes from both sides.',
          subtitle: 'Financial teams deal with sophisticated attack pressure and strong operational scrutiny at the same time. They need proof that the stack works and that the right things are being fixed.',
          type: 'text',
          graphic: 'Threat pressure + oversight panel.'
        }, {
          title: 'Complex stacks create complex blind spots.',
          subtitle: 'Controls, detections, workflows, and identities often span many systems. Picus helps turn that complexity into validated visibility.',
          type: 'text',
          graphic: 'Large financial stack with connected validation spine.'
        }, {
          title: 'Evidence matters more than reassurance.',
          subtitle: 'Teams need defensible proof of control performance, exploitability, and readiness. Picus helps generate that evidence.',
          type: 'text',
          graphic: 'Executive-ready financial risk / readiness board.'
        }]} data-id="element-68" />} data-id="element-67" />

          <Route path="/industries/healthcare" element={<GenericPage hero={{
          headline: 'Validate readiness where downtime and disruption hit hardest',
          subhead: 'Healthcare teams deal with vulnerable environments, critical systems, and limited tolerance for operational disruption. Picus helps validate what matters before small gaps become major events.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See HIPAA',
            to: '/frameworks-and-compliance/hipaa'
          }
        }} modules={[{
          title: 'Healthcare environments are operationally fragile.',
          subtitle: 'Clinical systems, connected devices, identities, and business systems create a large surface area with little room for disruption.',
          type: 'text',
          graphic: 'Connected healthcare environment map.'
        }, {
          title: 'Validation helps reduce uncertainty.',
          subtitle: 'Picus helps teams prove whether controls work, prioritize what matters, and avoid wasting effort on noise in already resource-constrained environments.',
          type: 'text',
          graphic: 'Validated queue over healthcare environment.'
        }, {
          title: 'Protection and continuity both matter.',
          subtitle: 'In healthcare, the question is not just whether something is exposed. It is whether an issue could disrupt the delivery of care.',
          type: 'text',
          graphic: 'Exposure path to service disruption.'
        }]} data-id="element-70" />} data-id="element-69" />

          <Route path="/industries/it-ot" element={<GenericPage hero={{
          headline: 'Validate across environments that were never built to move at the same pace',
          subhead: 'IT and OT teams often operate with different systems, different controls, and different constraints. Picus helps bridge validation across both worlds.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See the Platform',
            to: '/platform'
          }
        }} modules={[{
          title: 'IT and OT rarely share the same validation model.',
          subtitle: 'One side changes fast. The other side changes cautiously. Picus helps create a shared validation layer across both.',
          type: 'text',
          graphic: 'Fast-change IT lane versus stable OT lane joined by validation.'
        }, {
          title: 'Visibility without context is not enough.',
          subtitle: 'Teams need to understand what is exposed, what paths matter, and where controls actually hold across connected environments.',
          type: 'text',
          graphic: 'IT / OT path and control map.'
        }, {
          title: 'Validation has to respect operational reality.',
          subtitle: 'Picus is designed to help teams validate carefully, not just test aggressively.',
          type: 'text',
          graphic: 'Controlled validation path.'
        }]} data-id="element-72" />} data-id="element-71" />

          <Route path="/industries/critical-infrastructure" element={<GenericPage hero={{
          headline: 'Validate what matters where failure has public consequences',
          subhead: 'Critical infrastructure teams cannot rely on generic assurance. Picus helps validate controls, exposures, and attack paths in environments where resilience matters most.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See the Platform',
            to: '/platform'
          }
        }} modules={[{
          title: 'Operational resilience starts with proof.',
          subtitle: 'These environments demand more than visibility. Teams need evidence that controls and response paths actually hold up.',
          type: 'text',
          graphic: 'Control room with validation indicators.'
        }, {
          title: 'The cost of uncertainty is higher here.',
          subtitle: 'Where service disruption has broad impact, teams need to know what is real, what matters, and what to fix first.',
          type: 'text',
          graphic: 'Exposure path to service impact.'
        }, {
          title: 'Picus helps reduce the guesswork.',
          subtitle: 'Validation sharpens priorities and supports better resilience decisions.',
          type: 'text',
          graphic: 'Validated action queue in a utility context.'
        }]} data-id="element-74" />} data-id="element-73" />

          <Route path="/industries/manufacturing" element={<GenericPage hero={{
          headline: 'Validate the paths that put operations at risk',
          subhead: 'Manufacturing teams need to understand which weaknesses actually threaten production, safety, and continuity. Picus helps reduce noise and focus on what matters most.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Attack Path Validation',
            to: '/platform/attack-path-validation'
          }
        }} modules={[{
          title: 'Production environments are interconnected.',
          subtitle: 'Manufacturing systems often depend on many linked assets, identities, and controls. Picus helps validate where those connections create real operational risk.',
          type: 'text',
          graphic: 'Plant systems and paths map.'
        }, {
          title: 'Not every weakness affects production.',
          subtitle: 'The priority is understanding which paths and exposures can actually lead to disruption or unsafe conditions.',
          type: 'text',
          graphic: 'Dead-end path vs production-impact path.'
        }, {
          title: 'Prioritize what would actually hurt.',
          subtitle: 'Validation helps teams act on the paths that matter instead of chasing every signal equally.',
          type: 'text',
          graphic: 'Validated queue overlay on plant map.'
        }]} data-id="element-76" />} data-id="element-75" />

          <Route path="/industries/retail-ecommerce" element={<GenericPage hero={{
          headline: 'Validate controls and exposures across fast-moving retail environments',
          subhead: 'Retail environments change quickly and connect many systems, identities, and third parties. Picus helps validate what works and what should be fixed first.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Exposure Validation',
            to: '/platform/exposure-validation'
          }
        }} modules={[{
          title: 'Retail stacks move fast.',
          subtitle: 'Retail teams often operate across stores, cloud services, apps, payment systems, and third parties. Picus helps bring those moving parts into one validation picture.',
          type: 'text',
          graphic: 'Retail ecosystem map.'
        }, {
          title: 'External exposure matters more than ever.',
          subtitle: 'Customer-facing systems create constant pressure to understand what is visible, exploitable, and urgent.',
          type: 'text',
          graphic: 'External exposure path to payment / customer data.'
        }, {
          title: 'Fewer blind spots, faster decisions.',
          subtitle: 'Validation helps retail teams reduce noise and respond with more confidence.',
          type: 'text',
          graphic: 'Validated queue with customer-critical labels.'
        }]} data-id="element-78" />} data-id="element-77" />

          <Route path="/industries/public-sector" element={<GenericPage hero={{
          headline: 'Validate readiness where accountability is high and resources are limited',
          subhead: 'Public sector teams need to defend critical systems under scrutiny, often with constrained teams and long approval chains. Picus helps validate and prioritize with evidence.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Prove Readiness',
            to: '/use-cases/prove-readiness'
          }
        }} modules={[{
          title: 'High scrutiny. Limited resources.',
          subtitle: 'Public sector teams often have to prove readiness with fewer resources and slower internal processes.',
          type: 'text',
          graphic: 'Scrutiny + resource constraint visual.'
        }, {
          title: 'Validation supports better prioritization.',
          subtitle: 'Picus helps teams focus on the work that actually matters instead of spreading effort too broadly.',
          type: 'text',
          graphic: 'Long backlog compressing into prioritized queue.'
        }, {
          title: 'Evidence helps support leadership decisions.',
          subtitle: 'Evidence-backed readiness is easier to defend than assumptions.',
          type: 'text',
          graphic: 'Executive-ready report panel.'
        }]} data-id="element-80" />} data-id="element-79" />

          <Route path="/industries/technology-saas" element={<GenericPage hero={{
          headline: 'Validate faster in environments that change constantly',
          subhead: 'Technology teams ship quickly, change often, and cannot afford validation to lag behind delivery. Picus helps keep pace with environment and policy changes.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Picus Swarm',
            to: '/platform/picus-swarm'
          }
        }} modules={[{
          title: 'Change velocity creates validation pressure.',
          subtitle: 'Where teams change code, policy, and infrastructure quickly, validation has to keep pace or risk becomes stale by default.',
          type: 'text',
          graphic: 'Fast release timeline with validation overlays.'
        }, {
          title: 'Signals come from everywhere.',
          subtitle: 'Assets, identities, controls, detections, and workflow systems all change at speed. Picus helps turn those signals into useful validation.',
          type: 'text',
          graphic: 'Many fast-moving signals feeding one decision engine.'
        }, {
          title: 'AI-native platforms still need proof.',
          subtitle: 'Even modern stacks need validation grounded in real context. Picus helps provide that proof.',
          type: 'text',
          graphic: 'AI-native stack with proof checkpoints.'
        }]} data-id="element-82" />} data-id="element-81" />

          {/* Framework Sub-pages */}
          <Route path="/frameworks-and-compliance/ctem" element={<GenericPage hero={{
          headline: 'Turn CTEM into a repeatable operating model',
          subhead: 'CTEM requires more than discovery and prioritization. Picus adds the validation and revalidation layer that helps teams prove which exposures matter and whether actions worked.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Exposure Validation',
            to: '/platform/exposure-validation'
          }
        }} modules={[{
          title: 'Discovery alone is not enough.',
          subtitle: 'CTEM becomes useful when discovery is followed by proof, action, and revalidation.',
          type: 'text',
          graphic: 'CTEM loop with validation emphasized.'
        }, {
          title: 'Validation is the hard step.',
          subtitle: 'Many teams can identify exposures. Fewer can consistently prove which ones matter in practice.',
          type: 'text',
          graphic: 'Exposure list narrowing through validation.'
        }, {
          title: 'Picus helps close the loop.',
          subtitle: 'Picus supports the movement from exposure discovery to validated action and retesting.',
          type: 'text',
          graphic: 'Find → validate → act → revalidate loop.'
        }]} data-id="element-84" />} data-id="element-83" />

          <Route path="/frameworks-and-compliance/mitre-attack" element={<GenericPage hero={{
          headline: 'Validate against the techniques that matter',
          subhead: 'MITRE ATT&CK gives teams a shared language for attack behavior. Picus helps turn that language into practical validation of controls, detections, and attack scenarios.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See BAS',
            to: '/breach-and-attack-simulation'
          }
        }} modules={[{
          title: 'Shared taxonomy is useful. Evidence is better.',
          subtitle: 'Frameworks help teams describe attack behavior. Picus helps teams prove how their environment responds to that behavior.',
          type: 'text',
          graphic: 'Technique → validation outcome path.'
        }, {
          title: 'Built for operators, not just reporting.',
          subtitle: 'The value of MITRE alignment is stronger when it supports real testing, tuning, and prioritization.',
          type: 'text',
          graphic: 'Operator workflow over ATT&CK map.'
        }, {
          title: 'Map behavior to real readiness.',
          subtitle: 'Picus helps teams understand what the framework means in their actual environment.',
          type: 'text',
          graphic: 'Environment-specific MITRE map.'
        }]} data-id="element-86" />} data-id="element-85" />

          <Route path="/frameworks-and-compliance/dora" element={<GenericPage hero={{
          headline: 'Validate operational resilience, not just paperwork',
          subhead: 'DORA increases pressure on teams to show resilience in practice, not just policy. Picus helps validate whether controls and response posture actually hold up.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Prove Readiness',
            to: '/use-cases/prove-readiness'
          }
        }} modules={[{
          title: 'Readiness has to be operational.',
          subtitle: 'Resilience is harder to defend when it is based only on documentation. Validation gives teams evidence of performance.',
          type: 'text',
          graphic: 'Policy doc versus validated resilience state.'
        }, {
          title: 'Controls need proof.',
          subtitle: 'Picus helps teams understand whether controls and response processes are actually holding up under realistic conditions.',
          type: 'text',
          graphic: 'Control → simulated stress → result.'
        }, {
          title: 'Evidence supports stronger decisions.',
          subtitle: 'Evidence-backed readiness is easier to explain, defend, and improve.',
          type: 'text',
          graphic: 'Executive-ready evidence panel.'
        }]} data-id="element-88" />} data-id="element-87" />

          <Route path="/frameworks-and-compliance/hipaa" element={<GenericPage hero={{
          headline: 'Validate controls in environments where protection and continuity matter',
          subhead: 'HIPAA creates real expectations around protection and operational discipline. Picus helps teams generate evidence that controls and exposure priorities align with that responsibility.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Healthcare',
            to: '/industries/healthcare'
          }
        }} modules={[{
          title: 'Requirements are only part of the story.',
          subtitle: 'Teams still need to know whether controls work in practice and whether critical exposures are being prioritized correctly.',
          type: 'text',
          graphic: 'Requirement list feeding into validation.'
        }, {
          title: 'Protection and continuity both matter.',
          subtitle: 'Validation helps healthcare teams focus on the issues that could actually affect patient care or critical systems.',
          type: 'text',
          graphic: 'Exposure path to care disruption.'
        }, {
          title: 'Proof is easier to defend.',
          subtitle: 'Evidence-backed control validation is easier to explain than abstract assurance.',
          type: 'text',
          graphic: 'Evidence dashboard.'
        }]} data-id="element-90" />} data-id="element-89" />

          <Route path="/frameworks-and-compliance/nist-csf" element={<GenericPage hero={{
          headline: 'Add evidence to framework alignment',
          subhead: 'Framework alignment is useful. Evidence is better. Picus helps teams show whether the controls and processes behind NIST CSF expectations are working in practice.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Security Control Validation',
            to: '/platform/security-control-validation'
          }
        }} modules={[{
          title: 'Frameworks help structure the work.',
          subtitle: 'The harder part is proving the work actually changed readiness.',
          type: 'text',
          graphic: 'Structured framework on left, validation evidence on right.'
        }, {
          title: 'Picus helps connect framework to practice.',
          subtitle: 'Validation data makes it easier to understand whether aligned controls and processes are truly working.',
          type: 'text',
          graphic: 'Framework → control → validation outcome.'
        }, {
          title: 'Readiness should be measurable.',
          subtitle: 'The value of alignment increases when teams can show evidence of performance over time.',
          type: 'text',
          graphic: 'Trend line over NIST pillars.'
        }]} data-id="element-92" />} data-id="element-91" />

          <Route path="/frameworks-and-compliance/pci-dss" element={<GenericPage hero={{
          headline: 'Validate the controls that protect payment systems',
          subhead: 'Payment environments need more than policy alignment. Picus helps teams validate whether the controls around critical payment paths are actually working.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Retail',
            to: '/industries/retail-ecommerce'
          }
        }} modules={[{
          title: 'Critical payment paths deserve proof.',
          subtitle: 'The more sensitive the system, the more valuable evidence becomes.',
          type: 'text',
          graphic: 'Payment path validation map.'
        }, {
          title: 'Reduce blind spots in the cardholder environment.',
          subtitle: 'Picus helps teams validate controls, paths, and exposures in environments where assurance has to be stronger than theory.',
          type: 'text',
          graphic: 'Cardholder environment with validated risk zones.'
        }]} data-id="element-94" />} data-id="element-93" />

          <Route path="/frameworks-and-compliance/nis2" element={<GenericPage hero={{
          headline: 'Support resilience decisions with evidence',
          subhead: 'NIS2 increases pressure on teams to show maturity and operational readiness. Picus helps provide evidence that controls and priorities reflect reality, not just process.',
          primaryCta: {
            label: 'Get a Demo',
            to: '/contact'
          },
          secondaryCta: {
            label: 'See Critical Infrastructure',
            to: '/industries/critical-infrastructure'
          }
        }} modules={[{
          title: 'Operational proof matters more as scrutiny rises.',
          subtitle: 'Validation helps teams defend their decisions with evidence instead of assumptions.',
          type: 'text',
          graphic: 'Scrutiny versus proof visual.'
        }, {
          title: 'Picus sharpens what to act on.',
          subtitle: 'Better prioritization and stronger validation make resilience conversations more grounded.',
          type: 'text',
          graphic: 'Validated priority queue.'
        }]} data-id="element-96" />} data-id="element-95" />

          {/* Free Trial */}
          <Route path="/free-trial" element={<div className="pt-40 pb-20 max-w-2xl mx-auto px-6 text-center min-h-[60vh] flex flex-col items-center justify-center" data-id="element-98">
                <h1 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-99">
                  Start your free trial
                </h1>
                <p className="text-picus-muted text-lg mb-10 leading-relaxed" data-id="element-100">
                  Get full access to Picus Platform for 14 days. No credit card
                  required. See validated results in your environment within
                  hours.
                </p>
                <div className="w-full max-w-md space-y-4" data-id="element-101">
                  <input type="email" placeholder="Work email" className="w-full px-5 py-3.5 bg-picus-surface border border-picus-border rounded-lg text-white placeholder:text-picus-muted focus:outline-none focus:border-picus-blue transition-colors" data-id="element-102" />
                  <input type="text" placeholder="Company name" className="w-full px-5 py-3.5 bg-picus-surface border border-picus-border rounded-lg text-white placeholder:text-picus-muted focus:outline-none focus:border-picus-blue transition-colors" data-id="element-103" />
                  <button className="w-full px-5 py-3.5 bg-white text-black font-medium rounded-lg hover:bg-gray-200 transition-colors" data-id="element-104">
                    Start Free Trial
                  </button>
                  <p className="text-xs text-picus-muted" data-id="element-105">
                    14-day trial · No credit card · Full platform access
                  </p>
                </div>
              </div>} data-id="element-97" />

          {/* Contact / Demo */}
          <Route path="/contact" element={<div className="pt-40 pb-20 max-w-2xl mx-auto px-6 text-center min-h-[60vh] flex flex-col items-center justify-center" data-id="element-107">
                <h1 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-108">
                  Get a demo
                </h1>
                <p className="text-picus-muted text-lg mb-10 leading-relaxed" data-id="element-109">
                  See how Picus Platform validates your defenses, prioritizes
                  real exposure, and accelerates remediation — in your
                  environment.
                </p>
                <div className="w-full max-w-md space-y-4" data-id="element-110">
                  <input type="text" placeholder="Full name" className="w-full px-5 py-3.5 bg-picus-surface border border-picus-border rounded-lg text-white placeholder:text-picus-muted focus:outline-none focus:border-picus-blue transition-colors" data-id="element-111" />
                  <input type="email" placeholder="Work email" className="w-full px-5 py-3.5 bg-picus-surface border border-picus-border rounded-lg text-white placeholder:text-picus-muted focus:outline-none focus:border-picus-blue transition-colors" data-id="element-112" />
                  <input type="text" placeholder="Company name" className="w-full px-5 py-3.5 bg-picus-surface border border-picus-border rounded-lg text-white placeholder:text-picus-muted focus:outline-none focus:border-picus-blue transition-colors" data-id="element-113" />
                  <button className="w-full px-5 py-3.5 bg-white text-black font-medium rounded-lg hover:bg-gray-200 transition-colors" data-id="element-114">
                    Request Demo
                  </button>
                </div>
              </div>} data-id="element-106" />

          {/* Fallback for unbuilt pages */}
          <Route path="*" element={<div className="pt-40 pb-20 text-center min-h-[60vh] flex flex-col items-center justify-center" data-id="element-116">
                <h1 className="text-4xl font-serif mb-4" data-id="element-117">
                  Page under construction
                </h1>
                <p className="text-picus-muted" data-id="element-118">
                  This mock route hasn't been fully populated yet.
                </p>
              </div>} data-id="element-115" />
        </Routes>
      </Layout>
    </Router>;
}